import React, { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useLocation, useNavigate } from "react-router-dom";
import { Store } from "../../Store";
import axios from "axios";

function RegisterScreen() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const redirectInUrl = new URLSearchParams(search).get("redirect");
  const redirect = redirectInUrl ? redirectInUrl : "/home";

  const [username, setUsername] = useState("");
  const [userPhone, setUserPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo, baseUrl } = state;

  const submitHandler = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }
    if (!username || !email || !password) {
      alert("All fields are required");
      return;
    }

    try {
      const { data } = await axios.post(`${baseUrl}/user/register`, {
        email: email.trim().toLowerCase(),
        password,
        username: username.trim().toLowerCase(),
        phone: userPhone,
      });
      ctxDispatch({ type: "USER_SIGNIN", payload: data });
      localStorage.setItem("userInfo", JSON.stringify(data));
      navigate(redirect || "/home");
    } catch (err) {
      alert(err.response.data.message);
    }
  };

  useEffect(() => {
    if (userInfo) {
      navigate(redirect);
    }
  }, [navigate, redirect, userInfo]);

  const formContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    flexDirection: "column",
    background: "url('/images/Key.webp') no-repeat center/cover",
    // height: "100vh",
  };

  const formContainer = {
    // width:'25vw',
    border: "1px solid transparent",
    padding: "20px",
    borderRadius: "10px",
    alignItems: "center",
    backgroundColor: "whitesmoke",
  };

  const loginFormStyle = {
    width: "100%",
  };

  return (
    <div style={formContainerStyle}>
      <h2 style={{ textAlign: "center", color: "white" }}>KYEKYEKU TECH</h2>
      <div style={{ textAlign: "center", marginBottom: "-25px", backgroundColor:'white', borderRadius:'50%', padding:'10px' }}>
        <img
          src="/images/logoc.png"
          alt="Logo"
          style={{
            width: "90px",
            height: "90px",
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      </div>
      <div style={formContainer} className="col-9 col-lg-3">
      <p className="text-center fw-bold">REGISTER HERE</p>
        <Form style={loginFormStyle} onSubmit={submitHandler}>
          <Form.Group className="mb-1" controlId="username">
            {/* <Form.Label>Username</Form.Label> */}
            <Form.Control
              type="text"
              placeholder="Username"
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group className="mb-1" controlId="userPhone">
            {/* <Form.Label>Phone Number</Form.Label> */}
            <Form.Control
              type="text"
              placeholder="Phone number"
              maxLength="10"
              pattern="[0-9]*"
              inputMode="numeric"
              onChange={(e) =>
                setUserPhone(e.target.value.replace(/[^0-9]/g, ""))
              }
              required
            />
          </Form.Group>
          <Form.Group className="mb-1" controlId="email">
            {/* <Form.Label>Email address</Form.Label> */}
            <Form.Control
              type="email"
              placeholder="Enter email"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-1" controlId="password">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter Password"
              minLength={8}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-1" controlId="confirmPassword">
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control
              type="password"
              minLength={8}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Repeat Password"
              required
            />
          </Form.Group>
          <Button variant="primary" className="w-100" type="submit">
            Register
          </Button>
          <p
            onClick={() => navigate("/")}
            className="my-1 text-center"
            style={{ cursor: "pointer", color: "red",fontSize: "0.8em" }}
          >
            Already have Account? Login
          </p>
        </Form>
      </div>
    </div>
  );
}

export default RegisterScreen;
